const getData = state => state.data;

const getIsError = state => state.isError;

const getLoading = state => state.loading;

const getPagination = state => state.pagination;

const getToken = state => state.token;

const getRefreshAt = state => state.refreshAt;

export default {
  getData,
  getIsError,
  getLoading,
  getPagination,
  getToken,
  getRefreshAt,
};
